import Calendar from "components/commons/Calendar";
import secondsToHms from '../../../../utility/SecondToHms';
import { useTranslation } from 'react-i18next';
import UserImage from "components/commons/UserImage";

export default function TimeOffCalendar({
    data,
    isFetching,
    isSuccess,
    refetch
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])



    // Funzione per gestire il cambio mese
    const handleMonthChange = (start, end) => {
        const startMillis = Math.floor(new Date(start).getTime() / 1000);
        const endMillis = Math.floor(new Date(end).getTime() / 1000)-1
        refetch(startMillis, endMillis)
    };

    // Mappatura degli eventi
    let events = [];
    if (isSuccess) {
        // Mappatura delle assenze
        events = data.map(absence => {
            let startDate = new Date(absence.startDate * 1000);
            let endDate = new Date((absence.endDate + 86400) * 1000); // Aggiungi un giorno

            let formattedStartDate = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`;
            let formattedEndDate = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}`;

            return {
                id: absence.guid,
                title: `${absence.userDisplayName}`,
                img: <UserImage guid={absence.userGuid} size={40} border="true" />,
                type: absence.statsType,
                start: formattedStartDate,
                end: formattedEndDate,
                hours: absence.effectiveHours,
                color: getColor(absence.statsType),
                borderColor: "black",
                borderRadius: "10px"
            };
        });
    }

    function getIcon(type) {
        switch (type) {
            case "HOLIDAY": return <i className="fa-solid fa-umbrella-beach"></i>
            case "OVERTIME": return <i className="fa-regular fa-calendar-plus"></i>
            case "SICK": return <i className="fa-solid fa-house-chimney-medical"></i>
            case "PERMIT": return <i className="fa-solid fa-clock"></i>
            default: return
        }
    }


    function getColor(type) {
        console.log("colorType: " + type)
        switch (type) {
            case "OVERTIME": return "#198754"
            case "SICK": return "#dc3545"
            case "PERMIT": return "gray"
            default: return
        }
    }

    function renderEventContent(eventInfo) {
        return (
            <div key={eventInfo.event.id} className="p-1">
                <div className="row">
                    <div className="col-auto">
                        {eventInfo.event.extendedProps.img}
                    </div>
                    <div className="col">
                        <i>{getIcon(eventInfo.event.extendedProps.type)}  {secondsToHms((eventInfo.event.extendedProps.hours) * 60 * 60) != '' ? secondsToHms((eventInfo.event.extendedProps.hours) * 60 * 60) : "--"}</i>

                    </div>
                </div>
                <div className="row mt-1">
                    <h6>{eventInfo.event.title}</h6>
                </div>
            </div>
        )
    }

    return (
        <div className="card bg-black bg-opacity-10 text-white mb-5">
            <div className="card-header">
                Calendar
            </div>
            <div className={`card-body text-center  ${isFetching && "opacity-50"}`}>
                <Calendar
                    events={events}
                    onMonthChange={handleMonthChange}
                    renderEventContent={renderEventContent}
                />
            </div>
        </div>
    );
}

